 import React, { useEffect } from 'react';
 import { useNavigate } from 'react-router-dom';
 import Spinner from 'react-bootstrap/Spinner';
 import { onLogout } from "../../controller/LoginController";

const Logout = () => {
    const navigate = useNavigate();

    const logout = async () => {
        const logout = await onLogout();
    };

    useEffect(() => {
        logout()
        .then(() => {
            navigate("/login");
            window.location.reload();
        })
    });

    return (
        <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    );
}

export default Logout;
